<div *ngIf="sale" class="container">
  <order-number-header [order]="sale.order"></order-number-header>
  <order-item-summary [item]="sale.order.items[itemIndex]" [order]="sale.order"></order-item-summary>
  <order-item-history
    [dataSource]="sale.order.items[itemIndex].history"
  ></order-item-history>
</div>
